import {get} from 'lodash'

export function upgrade(userSettings) {

  const favoriteFonts = get(userSettings, 'favorites.fonts', [])

  userSettings.favorites.fonts = favoriteFonts.map((favoriteFontFamily, idx) => ({
    family: favoriteFontFamily,
    creationDate: (new Date((Date.UTC(1970, 1, 1, 0, 0, idx)))).toISOString()
  }))
}

export const DEFAULT_SETTINGS = {
  myColors: [],
  welcomeBannerSeen: false,
  isLiked: false,
  isQuickMenuShown: false,
  tips: {
    version: 0
  },
  favorites: {
    fonts: []
  },
  preferences: {
    autoConfirmSwapVideo: false
  }
}
